import { makeStyles } from '@material-ui/styles'
import { Theme } from 'styling/theme'

export default makeStyles((theme: Theme) => ({
    image: {
        width: '1em',
        height: '1em',
        display: 'inline-block',
        fontSize: 24,
        minWidth: 50,
    },
    icon: {
        minWidth: 50,
        fontSize: 24,
    },
    link: {
        color: theme.colors.white,
        marginTop: 20,
        marginBottom: 20,
        display: 'flex',
        fontSize: 14,
        fontFamily: theme.typographyPresets.fonts.monserrat.regular,

        '&:hover': {
            color: theme.colors.white,
            textDecoration: 'underline',
        },
    },
    iconName: {
        marginLeft: 5,
        textTransform: 'capitalize',
    },
}))
